<template>
  <svg
    class="lot__timer__icon"
    viewBox="0 0 18 20.998291"
    width="18"
    height="20.998291"
  >
    <path
      d="M 12.038968,0 H 6.0389676 V 2 H 12.038968 Z M 8.0389676,13
         H 10.038968 V 7 H 8.0389676 Z m 8.0000004,-6.61 1.45,-1.39
         a 11,11 0 0 0 -1.45,-1.44 l -1.38,1.44 a 9,9 0 1 0 1.38,1.39
         z M 9.0389676,19 a 7,7 0 1 1 7.0000004,-7 7,7 0 0 1 -7.0000004,7 z"
    />
  </svg>
</template>

<script>
export default {
  name: 'TimerIcon',
};
</script>



// WEBPACK FOOTER //
// src/components/elements/TimerIcon.vue